import { type FC } from 'react'

import agreements from '@core/assets/v2/icons/files/regular/Icon-Agreements-Regular.svg'
import agreementsCrossed from '@core/assets/v2/icons/files/regular/Icon-AgreementsCrossed-Regular.svg'
import csv from '@core/assets/v2/icons/files/regular/Icon-CSV-Regular.svg'
import doc from '@core/assets/v2/icons/files/regular/Icon-Doc-Regular.svg'
import file from '@core/assets/v2/icons/files/regular/Icon-File-Regular.svg'
import fileArrow from '@core/assets/v2/icons/files/regular/Icon-FileArrow-Regular.svg'
import fileCheck from '@core/assets/v2/icons/files/regular/Icon-FileCheck-Regular.svg'
import fileCode from '@core/assets/v2/icons/files/regular/Icon-FileCode-Regular.svg'
import fileDollar from '@core/assets/v2/icons/files/regular/Icon-FileDollar-Regular.svg'
import fileGear from '@core/assets/v2/icons/files/regular/Icon-FileGear-Regular.svg'
import fileLines from '@core/assets/v2/icons/files/regular/Icon-FileLines-Regular.svg'
import filePlus from '@core/assets/v2/icons/files/regular/Icon-FilePlus-Regular.svg'
import filePreview from '@core/assets/v2/icons/files/regular/Icon-FilePreview-Regular.svg'
import fileRefactor from '@core/assets/v2/icons/files/regular/Icon-FileRefactor-Regular.svg'
import fileRejected from '@core/assets/v2/icons/files/regular/Icon-FileRejected-Regular.svg'
import fileScan from '@core/assets/v2/icons/files/regular/Icon-FileScan-Regular.svg'
import fileSearch from '@core/assets/v2/icons/files/regular/Icon-FileSearch-Regular.svg'
import files from '@core/assets/v2/icons/files/regular/Icon-Files-Regular.svg'
import orderBacklog from '@core/assets/v2/icons/files/regular/Icon-OrderBacklog-Regular.svg'
import pdf from '@core/assets/v2/icons/files/regular/Icon-PDF-Regular.svg'
import withdrawFile from '@core/assets/v2/icons/files/regular/Icon-WithdrawFile-Regular.svg'
import xls from '@core/assets/v2/icons/files/regular/Icon-XLS-Regular.svg'
import xlsx from '@core/assets/v2/icons/files/regular/Icon-XLSX-Regular.svg'
import agreementsSolid from '@core/assets/v2/icons/files/solid/Icon-Agreements-Solid.svg'
import docSolid from '@core/assets/v2/icons/files/solid/Icon-Doc-Solid.svg'
import fileSolid from '@core/assets/v2/icons/files/solid/Icon-File-Solid.svg'
import fileArrowSolid from '@core/assets/v2/icons/files/solid/Icon-FileArrow-Solid.svg'
import fileCheckSolid from '@core/assets/v2/icons/files/solid/Icon-FileCheck-Solid.svg'
import fileCodeSolid from '@core/assets/v2/icons/files/solid/Icon-FileCode-Solid.svg'
import fileDollarSolid from '@core/assets/v2/icons/files/solid/Icon-FileDollar-Solid.svg'
import fileLinesSolid from '@core/assets/v2/icons/files/solid/Icon-FileLines-Solid.svg'
import fileSearchSolid from '@core/assets/v2/icons/files/solid/Icon-FileSearch-Solid.svg'
import pdfSolid from '@core/assets/v2/icons/files/solid/Icon-PDF-Solid.svg'
import withdrawFileSolid from '@core/assets/v2/icons/files/solid/Icon-WithdrawFile-Solid.svg'
import xlsSolid from '@core/assets/v2/icons/files/solid/Icon-XLS-Solid.svg'

import { createIcon } from './createIcon'
import type { FilesIconName, IconProps } from './types'

export const IconAgreements = createIcon(agreements, 'Agreements')
export const IconAgreementsCrossed = createIcon(agreementsCrossed, 'AgreementsCrossed')
export const IconCSV = createIcon(csv, 'CSV')
export const IconDoc = createIcon(doc, 'Doc')
export const IconFile = createIcon(file, 'File')
export const IconFileArrow = createIcon(fileArrow, 'FileArrow')
export const IconFileCheck = createIcon(fileCheck, 'FileCheck')
export const IconFileCodeRegular = createIcon(fileCode, 'FileCodeRegular')
export const IconFileDollar = createIcon(fileDollar, 'FileDollar')
export const IconFileGear = createIcon(fileGear, 'FileGear')
export const IconFileLines = createIcon(fileLines, 'FileLines')
export const IconFilePlus = createIcon(filePlus, 'FilePlus')
export const IconFilePreview = createIcon(filePreview, 'FilePreview')
export const IconFileRefactor = createIcon(fileRefactor, 'FileRefactor')
export const IconFileRejected = createIcon(fileRejected, 'FileRejected')
export const IconFileScan = createIcon(fileScan, 'FileScan')
export const IconFileSearch = createIcon(fileSearch, 'FileSearch')
export const IconFiles = createIcon(files, 'Files')
export const IconOrderBacklog = createIcon(orderBacklog, 'OrderBacklog')
export const IconPDF = createIcon(pdf, 'PDF')
export const IconWithdrawFile = createIcon(withdrawFile, 'WithdrawFile')
export const IconXLS = createIcon(xls, 'XLS')
export const IconXLSX = createIcon(xlsx, 'XLSX')
export const IconAgreementsSolid = createIcon(agreementsSolid, 'AgreementsSolid')
export const IconDocSolid = createIcon(docSolid, 'DocSolid')
export const IconFileSolid = createIcon(fileSolid, 'FileSolid')
export const IconFileArrowSolid = createIcon(fileArrowSolid, 'FileArrowSolid')
export const IconFileCheckSolid = createIcon(fileCheckSolid, 'FileCheckSolid')
export const IconFileCodeSolid = createIcon(fileCodeSolid, 'FileCodeSolid')
export const IconFileDollarSolid = createIcon(fileDollarSolid, 'FileDollarSolid')
export const IconFileLinesSolid = createIcon(fileLinesSolid, 'FileLinesSolid')
export const IconFileSearchSolid = createIcon(fileSearchSolid, 'FileSearchSolid')
export const IconPDFSolid = createIcon(pdfSolid, 'PDFSolid')
export const IconWithdrawFileSolid = createIcon(withdrawFileSolid, 'WithdrawFileSolid')
export const IconXLSSolid = createIcon(xlsSolid, 'XLSSolid')

export const fileIcons: Record<FilesIconName, FC<IconProps>> = {
    Agreements: IconAgreements,
    AgreementsCrossed: IconAgreementsCrossed,
    CSV: IconCSV,
    Doc: IconDoc,
    File: IconFile,
    FileArrow: IconFileArrow,
    FileCheck: IconFileCheck,
    FileCodeRegular: IconFileCodeRegular,
    FileDollar: IconFileDollar,
    FileGear: IconFileGear,
    FileLines: IconFileLines,
    FilePlus: IconFilePlus,
    FilePreview: IconFilePreview,
    FileRefactor: IconFileRefactor,
    FileRejected: IconFileRejected,
    FileScan: IconFileScan,
    FileSearch: IconFileSearch,
    Files: IconFiles,
    OrderBacklog: IconOrderBacklog,
    PDF: IconPDF,
    WithdrawFile: IconWithdrawFile,
    XLS: IconXLS,
    XLSX: IconXLSX,
    AgreementsSolid: IconAgreementsSolid,
    DocSolid: IconDocSolid,
    FileSolid: IconFileSolid,
    FileArrowSolid: IconFileArrowSolid,
    FileCheckSolid: IconFileCheckSolid,
    FileCodeSolid: IconFileCodeSolid,
    FileDollarSolid: IconFileDollarSolid,
    FileLinesSolid: IconFileLinesSolid,
    FileSearchSolid: IconFileSearchSolid,
    PDFSolid: IconPDFSolid,
    WithdrawFileSolid: IconWithdrawFileSolid,
    XLSSolid: IconXLSSolid,
}
